exports.components = {
  "component---src-components-templates-consulting-room-template-jsx": () => import("./../../../src/components/templates/consulting-room-template.jsx" /* webpackChunkName: "component---src-components-templates-consulting-room-template-jsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

